import {
  Button,
  InfoModalStyle,
  Close
} from "@/imports-files/components/common-modal/common-modal";
import parse from "html-react-parser";
import { useTranslation } from "react-i18next";

const InfoModal = (props) => {
  const {t} = useTranslation()
  const { content } = props;
  const points = [
    t('modal:info:search_guide:search_candidates'),
    t('modal:info:search_guide:boolean_operators'),
    t('modal:info:search_guide:search_results'),
    t('modal:info:search_guide:auto_stemming'),
  ];

  return (
    <div className={`${InfoModalStyle.ModalOverlay}`}>
      <div className={`${InfoModalStyle.Modal} ${props?.largeWidth && InfoModalStyle.ModalLarge} ${props?.mdWidth && InfoModalStyle.ModalMd} ${props?.hiredModal && InfoModalStyle.HiredPoup}`}>
        <div className={`${InfoModalStyle.Modal__Container}`}>
          <div className={`${InfoModalStyle.Modal__Container__Heading__Close} mb20`}>
          {props?.heading && (
                <h1
                  className={`${InfoModalStyle.Modal__Container__ContentSection__Heading} ${props.className} mt0`}
                >
                  {props?.heading}
                </h1>
              )}

           {props.noCloseIcon ? null : (<div
              className={`${InfoModalStyle.Modal__Container__CloseSection}`}
              onClick={() => {
                props?.closeModal();
              }}
            >
              <Close/>
            </div>)}
          </div>
          <div className={`${InfoModalStyle.Modal__Container__ContentSection} ${props.className}`}>

            {props?.case == "search" && (
              <ol
                className={`${InfoModalStyle.Modal__Container__ContentSection__ListContainer}`}
              >
                {points.map((point, index) => {
                  return (
                    <li
                      key={index}
                      className={
                        InfoModalStyle.Modal__Container__ContentSection__ListContainer__Points
                      }
                    >
                      {point}
                    </li>
                  );
                })}
              </ol>
            )}
            {props?.case == "privacyPolicy" && (
              <div
                className={
                  InfoModalStyle.Modal__Container__ContentSection__Description
                }
              >
                {parse(content)}
              </div>
            )}
            {props?.innerContent}
          </div>
          {props?.texts?.button1_text && (
            <div className={InfoModalStyle.Modal__Container__ButtonSection}>
              <Button
                buttonstyle={InfoModalStyle.primarybtn}
                onClick={() => {
                  props.closeModal();
                }}
              >
                {props?.texts?.button1_text || t('button:cancel')}
              </Button>
              {props?.texts?.button2_text && (
                <Button
                  buttonstyle={InfoModalStyle.secondarybtn}
                  onClick={() => {
                    props.btnAction();
                  }}
                >
                  {props?.texts?.button2_text || t('button:cancel')}
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default InfoModal;
